module.exports = __webpack_public_path__ + "img/DTKlogo.5a26fc45.png";